import { authedRequest, authedV3Request } from './requests'

/**
 *
 * /channels resource requests
 *
 */
/**
 *
 * /registrations resource requests
 *
 */
export const patchAccount =
  (token, data) => {
    // Build user object with only defined values to support partial updates
    const user = {};
    if (data.first_name !== undefined) user.first_name = data.first_name;
    if (data.last_name !== undefined) user.last_name = data.last_name;
    if (data.company !== undefined) user.company = data.company;
    if (data.email !== undefined) user.email = data.email;
    if (data.password !== undefined) user.password = data.password;
    // Rails requires it when email or password changes; the form only sends it then.
    if (data.current_password !== undefined) user.current_password = data.current_password;

    return authedRequest('v2/registrations', token, {
      method: 'PATCH',
      body: JSON.stringify({ user })
    }).then(r => r);
  }

export const resendEmailConfirmation =
  (token) => {
    authedRequest('v2/registration/resend_email_confirmation', token, {
      method: 'POST'
    })
  }

export const deleteAccount =
  (token, { currentPassword, confirmationText }) =>
    authedV3Request('v3/users/me', token, {
      method: 'DELETE',
      body: JSON.stringify({
        current_password: currentPassword,
        confirmation_text: confirmationText,
      })
    });
